import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Reconciliation {
    firstReconcilation: boolean;
    secondReconcilation: boolean;
    thirdReconcilation: boolean;
}

const initialState: Reconciliation = {
    firstReconcilation: false,
    secondReconcilation: false,
    thirdReconcilation: false,
};

const reconciliationSlice = createSlice({
    name: 'reconciliation',
    initialState,
    reducers: {
        firstRecFunc: (state, action: PayloadAction<boolean>) => {
            state.firstReconcilation = action.payload;
        },
        secondRecFunc: (state, action: PayloadAction<boolean>) => {
            state.secondReconcilation = action.payload;
        },
        thirdRecFunc: (state, action: PayloadAction<boolean>) => {
            state.thirdReconcilation = action.payload;
        },
    },
});

// Action'ları dışa aktar
export const { firstRecFunc, secondRecFunc, thirdRecFunc } = reconciliationSlice.actions;

export default reconciliationSlice.reducer;
